var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Info2 = function Info2(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 18 18' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        '!'
      ),
      React.createElement('path', { d: 'M10 12V7H8L7 9h1v3l-1 2h4l-1-2zM8 6h2V4H8v2zm1 11c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zM9 0a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Info2;
//# sourceMappingURL=Info2.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Info2.js